import { render, staticRenderFns } from "./TagMap.vue?vue&type=template&id=5b1b3db5&"
import script from "./TagMap.vue?vue&type=script&lang=js&"
export * from "./TagMap.vue?vue&type=script&lang=js&"
import style0 from "./TagMap.vue?vue&type=style&index=0&id=5b1b3db5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports